'use client';

import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import { Button } from '@src/components/Button/Button';
import { Checkbox } from '@src/components/Checkbox/Checkbox';
import { useLocale } from '@src/i18n/LocaleProvider';
export interface VideoWaiverProps {
  waiverAgreementBody?: string;
  onWaiverAccepted: () => void;
  onWaiverDeclined: () => void;
}
export const VideoWaiver = t0 => {
  const $ = _c(32);
  const {
    waiverAgreementBody,
    onWaiverAccepted,
    onWaiverDeclined
  } = t0;
  const {
    t
  } = useLocale("video-waiver");
  const [isChecked, setIsChecked] = useState(false);
  let t1;
  if ($[0] !== t || $[1] !== waiverAgreementBody) {
    t1 = waiverAgreementBody ?? t("body");
    $[0] = t;
    $[1] = waiverAgreementBody;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <div dangerouslySetInnerHTML={{
      __html: t1
    }} />;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = event => setIsChecked(event.target.checked);
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t) {
    t4 = t("checkbox-label");
    $[6] = t;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== isChecked || $[9] !== t4) {
    t5 = <div className="pt-4"><Checkbox checked={isChecked} onChange={t3}>{t4}</Checkbox></div>;
    $[8] = isChecked;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t2 || $[12] !== t5) {
    t6 = <div className="mt-2.5 flex-1 overflow-y-auto pr-2.5 leading-normal [&_p:first-of-type]:mt-0">{t2}{t5}</div>;
    $[11] = t2;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <hr className="my-3.5 mb-7 h-px border-0 bg-bodi-gray-medium" />;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t) {
    t8 = t("decline");
    $[15] = t;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== onWaiverDeclined || $[18] !== t8) {
    t9 = <Button variant="secondary" size="large" onClick={onWaiverDeclined} className="flex-1 capitalize">{t8}</Button>;
    $[17] = onWaiverDeclined;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  const t10 = !isChecked;
  let t11;
  if ($[20] !== t) {
    t11 = t("accept");
    $[20] = t;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== onWaiverAccepted || $[23] !== t10 || $[24] !== t11) {
    t12 = <Button variant="primary" size="large" disabled={t10} onClick={onWaiverAccepted} className="flex-1 capitalize disabled:cursor-not-allowed disabled:opacity-50">{t11}</Button>;
    $[22] = onWaiverAccepted;
    $[23] = t10;
    $[24] = t11;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== t12 || $[27] !== t9) {
    t13 = <div className="shrink-0">{t7}<div className="flex gap-2">{t9}{t12}</div></div>;
    $[26] = t12;
    $[27] = t9;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== t13 || $[30] !== t6) {
    t14 = <div className="absolute inset-0 z-20 flex items-stretch justify-center md:items-center"><div className="flex h-svh max-h-svh w-full max-w-full flex-col rounded-none bg-white px-[30px] pb-[30px] text-bodi-black-text md:h-auto md:max-h-[600px] md:max-w-[710px] md:rounded-[30px] md:px-[50px]">{t6}{t13}</div></div>;
    $[29] = t13;
    $[30] = t6;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  return t14;
};